<template>
    <div class="container div_show1 reg_completed">
        <div class="row">
            <div class="col-md-8 mx-auto" style="background: rgb(255, 255, 255);padding-left: 2rem;padding-right: 2rem;">
                <div class="row mb-4">
                    <div class="col-md-12">
                        <div class="head_line">Your Registration is Completed</div>
                    </div>
                </div>
                <div class="row mb-4">
                    <div class="col-md-12">
                        <h6>Congratulations!</h6>
                        <span>You have been successfully registered for our upcoming ( <strong>{{cn(event,'title','-')}}</strong> ) event. We appreciate your interest in exploring opportunities to study abroad.</span>
                    </div>
                </div>
                <div class="row mb-4">
                    <div class="col-md-12">
                        <div class="event_info_box">
                            <div class="row">
                                <div class="event_info_item col-md-6">
                                    <div class="row">
                                        <div class="col-md-2 col-2 pr-0">
                                            <i class="fa fa-map-pin"></i>
                                        </div>
                                        <div class="col-md-10 col-10 pl-0">
                                            <div class="info_title">Registration Reference</div>
                                            <div class="info_content">{{student_ref}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="event_info_item col-md-6">
                                    <div class="row">
                                        <div class="col-md-2 col-2 pr-0">
                                            <i class="fa fa-arrow-right"></i>
                                        </div>
                                        <div class="col-md-10 col-10 pl-0">
                                            <div class="info_title">Event Name</div>
                                            <div class="info_content">{{cn(event,'title','-')}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="event_info_item col-md-6 mt-4">
                                    <div class="row">
                                        <div class="col-md-2 col-2 pr-0">
                                            <i class="fa fa-calendar"></i>
                                        </div>
                                        <div class="col-md-10 col-10 pl-0">
                                            <div class="info_title">Date and Time</div>
                                            <div class="info_content">{{cn(event,'event_times_data.event_date')}}</div>
                                            <div class="info_content">From {{cn(event,'event_times_data.event_start_time')}} To {{cn(event,'event_times_data.event_end_time')}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="event_info_item col-md-6 mt-4">
                                    <div class="row">
                                        <div class="col-md-2 col-2 pr-0">
                                            <i class="fa fa-map-marker"></i>
                                        </div>
                                        <div class="col-md-10 col-10 pl-0">
                                            <div class="info_title">Location</div>
                                            <div class="info_content">{{cn(event,'venue_address','-')}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mb-4">
                    <div class="col-md-12">
                        <span>Thank you for choosing to embark on this exciting journey with us. We look forward to meeting you at the event.</span>
                        <br>
                        <br>
                        <span>For more information, please email at <a target="_blank" :href="'mailto:'+event.org_email">{{event.org_email}}</a> or call at <span style="color: darkblue">
                            <a :href="'tel:'+event.org_phn_number">+{{cn(event,'country.calling_code','')}} {{event.org_phn_number}}</a>    
                        </span></span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 text-center">
                        <span @click="(()=>{$emit('reset', true)})" class="hand back_link" >
                            <i class="fa fa-arrow-left"></i>  Go back to form
                        </span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="footer">
                            <div class="com_logo">
                                <img v-if="logo" :src="logo" class="img-fluid">
                                <img v-else :src="default_logo" class="img-fluid">
                            </div>
                            <div class="com_name mb-2">{{ company.name }}</div>
                            <div class="address">
                                {{ office.address }}, {{ cn(office,'country.name','') }}
                                <br>
                                <span v-if="contact_details && contact_details.phone_code != null && contact_details.phone != null">
                                    Telephone : 
                                    {{ contact_details.phone_code }} -
                                    {{ contact_details.phone }}
                                </span>,
                                <span v-if="contact_details && contact_details.mob_code != null && contact_details.mobile != null">
                                    <i class="fa fa-mobile"></i>
                                    {{ contact_details.mob_code }}
                                    {{ contact_details.mobile }}
                                </span>,
                                
                                <span v-if="office && office.email != null">
                                    Email:
                                    {{ office.email }}
                                </span>
                            </div>
                            <div class="credit">
                                &copy {{new Date().getFullYear()}} SAMS CRM
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:['company','event','logo','default_logo','contact_details','office','student_ref']
}
</script>

<style>
    .reg_completed{
        font-family: Helvetica, Arial, sans-serif;
        font-size: 13px;
        line-height: 1.4;
        text-align: left;
        color: #333e49;
    /*     text-align: center; */
    }
    .reg_completed .head_line{
        font-size: 23px;
        font-weight: 600;
        line-height: .9;
        text-align: center;
        color: #2e1153;
        border-bottom: 2px solid #e9f0f3;
        padding: 25px 0;
    }
    .reg_completed .event_info_box{
        /* width: fit-content;
        padding: 16px;
        margin: 0 auto;
        border: 1px solid #dae3e7;
        border-radius: 0.25rem; */
        margin: 20px 0;
    }
    .reg_completed .event_info_item .info_title{
        margin-bottom: 6px;
    /*     color: #868e96; */
        font-weight: 600;
        font-size: .85rem;
        margin-top: -2px;
    }
    .reg_completed .event_info_item .info_content{
    /*     font-weight: 600; */
    }
    .reg_completed .footer{
        text-align: center;
        border-top: 2px solid #e9f0f3;
        padding: 25px;
        color: #868e96;
        margin-top: 10px;
    }
    .reg_completed .footer .com_name{
        font-weight: 600;
        font-size: 1rem;
        color: #2e1153;
    }
    .reg_completed .footer .com_logo{
        width: 100px;
        margin: 0 auto;
        margin-bottom: 20px;
    }
    .reg_completed .footer .credit{
        opacity: .5;
        margin-top: 20px;
    }
    .reg_completed .event_info_item .fa{
        font-size: 1.65rem;
    }
    .reg_completed .event_info_item .fa-calendar{
        font-size: 1.25rem;
    }
    .reg_completed .event_info_item .fa-arrow-right{
        font-size: 1.40rem;
    }
    .reg_completed .event_info_item .col-md-2{
        text-align: center;
    }
    @media only screen and (max-width: 600px) {
        .reg_completed .event_info_item:nth-child(2) { 
            margin-top: 24px;
        }
    }

    .back_link{
        color: #0082c6;
        transition: .3s;
    }

    .back_link:hover{
        color: #000;
        border: 2px solid #0082c6;
        padding: 6px 10px;
        border-radius: 20px;
        transition: .3s;
    }
</style>